import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "I learned two things today 9.8.",
  "description": "",
  "published": "2011-08-09T00:00:00.000Z",
  "redirect_from": ["/blog/i-learned-two-things-today-9-8/swizec/2110"],
  "categories": "Learning, Personal",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/08/07ad0f735cb64150992323a48cc29fbc_75.jpg",
        "alt": null,
        "title": "Peanut+salt chocolate"
      }}></img></p>
    <p>{`Today I learned that weird looking `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Chocolate",
        "title": "Chocolate"
      }}>{`chocolates`}</a>{` can actually be pretty tasty. Finally broke down after almost two months of going practically without chocolate (I usually make at least a nibble a day) for almost two months and I just had to buy some. The selection at `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Whole_Foods_Market"
      }}>{`Whole Foods`}</a>{` is surprisingly opulent, but very expensive because everything is magically organic and fancy.`}</p>
    <p>{`In the end I settled on two bars of some brand I've never heard of that seemed reasonable. Surprisingly enough, chocolate with the flavour of peanuts and salt is pretty damn tasty.`}</p>
    <p>{`Another thing that I learned today is that `}<a parentName="p" {...{
        "href": "http://www.foursquare.com/",
        "title": "Foursquare"
      }}>{`Foursquare`}</a>{` has shut down its original `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Application_programming_interface",
        "title": "Application programming interface"
      }}>{`API`}</a>{` and now only supports the new version. Was fixing up my blog after javascript broke horrifically and my mixpanel metrics weren't collecting properly, half of the footer was missing and so on.`}</p>
    <p>{`Well I have a small widget that displays my last foursquare checkin. The checkin doesn't appear now and after a very long time debugging I finally got to a Foursquare error message saying, essentially, "This version no longer works. Please kindly fuck off".`}</p>
    <p>{`Wonder how many apps that breaks.`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://swizec.com/blog/i-learned-two-things-today-2-8/swizec/2059"
        }}>{`I learned two things today 2.8.`}</a>{` (swizec.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://sophisticatedspender.com/2011/08/08/what-i-learned-from-my-dc-chocolate-tour/"
        }}>{`What I Learned From My DC Chocolate Tour`}</a>{` (sophisticatedspender.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.ilyke.net/view/2332"
        }}>{`Did you know Chocolate is a Vegetable?`}</a>{` (ilyke.net)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=607e016a-df19-4035-8a21-1bcbbf598174",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      